"use client";
import { Menu, MenuItem, Button } from "@mui/material";
import { useSession, signOut } from "next-auth/react";
import {
  IdCard,
  LogOut,
  Info,
  MessageSquareHeart,
  FileText,
} from "lucide-react";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import Link from "next/link";
import { useWalesBetaAnalytics } from "~/app/lib/analytics/WalesBetaAnalyticsContext";

export default function UserMenu() {
  const { data: session, status } = useSession();
  const { reset: resetAnalytics } = useWalesBetaAnalytics();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    resetAnalytics();
    signOut({ callbackUrl: "/user/logoutSuccess" });
  };

  return (
    <>
      <Button
        id="Menu"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        data-cy="user_login_menu"
      >
        <MenuIcon sx={{ color: "white" }} />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ paper: { sx: { width: "9rem" } } }}
      >
        {session && (
          <MenuItem
            data-cy="user_login_menu_id"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
            disabled
          >
            {session.user.membershipId}
            <IdCard style={{ marginLeft: 8 }} />
          </MenuItem>
        )}
        <MenuItem
          component="a"
          href="https://r1.dotdigital-pages.com/p/7IPW-A2B/pay-checker-feedback"
          target="_blank"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          Feedback <MessageSquareHeart style={{ marginLeft: 8 }} />
        </MenuItem>
        <MenuItem
          component="a"
          href="https://www.bma.org.uk/pay-and-contracts/pay/payslips/how-to-use-pay-checker"
          target="_blank"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          Support <Info style={{ marginLeft: 8 }} />
        </MenuItem>
        <MenuItem
          component={Link}
          href="/terms"
          onClick={handleClose}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          Ts&Cs <FileText style={{ marginLeft: 8 }} />
        </MenuItem>
        {session && (
          <MenuItem
            onClick={handleLogout}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            Log out <LogOut style={{ marginLeft: 8 }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
